<template>
  <div ref="about" class="about">
    <!-- <div style="overflow:hidden;">
      <div class="innerBox" v-for="(item,index) in arrList" :key="index">
        <div class="currencyTitle animate__animated animate__fadeInUp" v-if="item.coverImage && item.title !== 'banner'">
          <img :src="item.coverImage" alt="">
          <h3>{{ item.title }}</h3>
        </div>
        <div v-html="item.content"></div>
      </div>
    </div> -->
    <div v-html="arrList.content"></div>
    <!-- 核心团队 -->
    <div class="comanyTeams" style="display:none;">
      <div class="currencyTitle">
        <img src="../assets/logo.png" alt />
        <h3>企业核心团队介绍</h3>
      </div>
      <div class="boxFull">
        <div class="boxFull1180">
          <div class="teams_photo">
            <img src="../assets/images/team_photo.jpg" alt />
            <div class="teamText">
              <div class="teamText_up">
                <p>刘德华</p>
                <p>ceo</p>
              </div>
              <div class="teamText_down animate__animated animate__zoomIn">
                <p>前阿里云资深产品专家；2016年回国之前在美国湾区安全公司FireEye， Cisco等从事产品管理工作。回国加入阿里云安全产品团队后，负责产品和运营团队</p>
              </div>
            </div>
          </div>
          <div class="teams_photo">
            <img src="../assets/images/team_photo.jpg" alt />
            <div class="teamText">
              <div class="teamText_up">
                <p>刘德华</p>
                <p>ceo</p>
              </div>
              <div class="teamText_down animate__animated animate__zoomIn">
                <p>前阿里云资深产品专家；2016年回国之前在美国湾区安全公司FireEye， Cisco等从事产品管理工作。回国加入阿里云安全产品团队后，负责产品和运营团队</p>
              </div>
            </div>
          </div>
          <div class="teams_photo">
            <img src="../assets/images/team_photo.jpg" alt />
            <div class="teamText">
              <div class="teamText_up">
                <p>刘德华</p>
                <p>ceo</p>
              </div>
              <div class="teamText_down animate__animated animate__zoomIn">
                <p>前阿里云资深产品专家；2016年回国之前在美国湾区安全公司FireEye， Cisco等从事产品管理工作。回国加入阿里云安全产品团队后，负责产品和运营团队</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 定制 -->
    <div class="styleBox_07 11" :style="{backgroundImage:'url('+ bgUrl +')'}">
      <p>智能化网络安全保障服务，即刻开启！</p>
      <a href="javascript:void(0);" class="comButton collection-1 btn-15">
        <span @click="toPlan">立即定制</span>
      </a>
    </div>
  </div>
</template>

<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
export default {
  components: { Header, Sidebar, Footer },
  data () {
    return {
      pageTips: '',
      arrList: [],
      bgUrl: ''
    }
  },
  methods: {
    // 获取导航数据ioo
    getAbout () {
      let arr = JSON.parse(localStorage.getItem('navList'))
      arr.forEach(item => {
        if (item.id == this.pageTips) {
          this.arrList = item.articleList[0]
        }
      })
    },
    toPlan () {
      this.$router.push('/getPlan')
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.id) { this.pageTips = this.$route.query.id }
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230101/img_gg_1672576300037.jpg'
    console.log(this.bgUrl)
    this.getAbout()
  },
  destroyed () {
  }
}
</script>
<style lang="less" scoped>
body {
  background: red;
}
// 移动端样式
@media only screen and (max-width: 1024px) {
  .styleBox_07 {
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2.125rem 0 1.5625rem;
    margin-top: 1.25rem;
  }
  .styleBox_07 p {
    font-size: 1rem;
    font-weight: 600;
    color: #08142a;
    margin-bottom: 1.5625rem;
  }
  .comButton {
    color: #fff;
    border-radius: 1rem;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    padding: 0;
    height: 1.875rem;
    font-size: 0.8125rem;
    margin: 0;
    padding: 0;
    max-width: 6.6875rem;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .about {
    width: 100%;
    background: #fff;
    // 按钮样式
    .comButton {
      position: relative;
      display: inline-block;
      padding: 15px 36px;
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    }
    .comButton:hover {
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 35%, #186ae8);
    }
    // banner图部分
    .banner {
      position: relative;
      .bannerText {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 2;
        div {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          h3 {
            font-size: 52px;
            font-weight: bold;
            color: #ffffff;
            line-height: 78px;
            letter-spacing: 5px;
            text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
            padding: 16px 51px;
            border: 1px solid rgba(255, 255, 255, 0.5);
            margin-bottom: 37px;
          }
          p {
            font-size: 30px;
            font-weight: bold;
            color: #ffffff;
            line-height: 42px;
            letter-spacing: 2px;
          }
        }
      }
      .bannerImg {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
    .box1180 {
      max-width: 1180px;
      margin: 0 auto;
      padding: 68px 56px 86px 46px;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 2px 12px 0px rgba(204, 204, 204, 0.5);
      border-radius: 24px;
      .company_01 {
        display: flex;
        justify-content: space-between;
        .company_01_L {
          h4 {
            font-size: 32px;
            font-weight: bold;
            color: #428bf8;
            margin-bottom: 31px;
            span {
              font-size: 20px;
              font-weight: 300;
            }
          }
          ul {
            li {
              font-size: 17px;
              font-weight: 300;
              color: #4c5461;
              margin-bottom: 16px;
              img {
                width: 20px;
                height: 20px;
                margin-right: 10px;
              }
            }
          }
          strong {
            font-size: 22px;
            font-weight: bold;
            color: #353535;
            line-height: 40px;
            margin-top: 25px;
          }
        }
        .company_01_R::before {
          content: '';
          display: inline-block;
          vertical-align: middle;
          height: 100%;
        }
        .company_01_R {
          width: 498px;
          img {
            width: 100%;
            vertical-align: middle;
          }
        }
      }
      .company_02 {
        display: flex;
        justify-content: space-between;
        margin-top: 21px;
        .company_02_L {
          img {
            width: 498px;
            margin-right: 92px;
          }
        }
        .company_02_R {
          p {
            font-size: 22px;
            font-weight: 500;
            color: #353535;
            i {
              color: #428bf8;
              font-size: 28px;
            }
          }
          span {
            display: block;
            font-size: 17px;
            font-weight: 300;
            color: #4c5461;
            margin: 25px 0;
          }
          h5 {
            font-size: 22px;
            font-weight: 500;
            color: #353535;
            i {
              color: #428bf8;
              font-size: 22px;
            }
          }
        }
      }
    }
    // 通用标题
    .currencyTitle {
      display: flex;
      justify-content: center;
      margin: 110px 0 85px 0;
      img {
        width: 69px;
        height: 54px;
      }
      h3 {
        color: #08142a;
        font-size: 32px;
        font-weight: bold;
        line-height: 45px;
        margin-left: 22px;
      }
    }
    .currencyTitleTip {
      margin-bottom: 40px;
    }
    .TitleTips {
      font-size: 18px;
      font-weight: 300;
      color: #4c5461;
      text-align: center;
      margin-bottom: 80px;
    }
    .boxFull {
      background: url('../assets/images/img_teams.jpg');
      padding: 81px 0 74px;
      .boxFull1180 {
        max-width: 1180px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
      }
      .teams_photo {
        width: 380px;
        height: 367px;
        border-radius: 12px;
        overflow: hidden;
        position: relative;
        box-shadow: 1px 1px 6px 1px #d3d3d3;
        display: flex;
        flex-direction: column;
        justify-content: end;
        cursor: pointer;
        img {
          width: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
        .teamText {
          position: relative;
          color: #ffffff;
          z-index: 9;
          width: 100%;
          background: linear-gradient(
            209deg,
            #3ee3ff 0%,
            #2e9efd 46%,
            #186ae8 100%
          );
          font-size: 20px;
          padding: 0 29px 0;
          box-sizing: border-box;
          .teamText_up {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 60px;
          }
          .teamText_down {
            font-size: 16px;
            padding-top: 21px;
            padding-bottom: 41px;
            position: relative;
            display: none;
          }
          .teamText_down::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 2px;
            background: linear-gradient(221deg, #cdf1ff 0%, #85cbff 100%);
            border-radius: 3px;
          }
        }
      }
      .teams_photo:hover .teamText_down {
        display: block;
      }
    }
    .styleBox_07 {
      width: 100%;
      height: 320px;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      line-height: 50px;
    }
    .styleBox_07 p {
      font-size: 32px;
      font-weight: 600;
      color: #08142a;
      margin-bottom: 44px;
    }
    .comButton {
      color: #fff;
      border-radius: 28px;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      padding: 0;
      height: 50px;
      font-size: 18px;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue